import React from 'react';
import { Modal, Button } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';

interface ErrorDialogProps {
    visible: boolean;
    title?: string;
    message: string;
    onClose: () => void;
    onRetry?: () => void;
    showRetry?: boolean;
    width?: number;
}

const ErrorDialog: React.FC<ErrorDialogProps> = ({
    visible,
    title = 'Error',
    message,
    onClose,
    onRetry,
    showRetry = false,
    width = 500
}) => {
    const footerButtons = [
        <Button key="ok" type="primary" onClick={onClose}>
            OK
        </Button>
    ];

    if (showRetry && onRetry) {
        footerButtons.unshift(
            <Button key="retry" onClick={onRetry}>
                Retry
            </Button>
        );
    }

    return (
        <Modal
            open={visible}
            onCancel={onClose}
            footer={footerButtons}
            title={title}
            centered
            width={width}
            destroyOnClose
        >
            <div style={{ textAlign: 'center', padding: '20px 0' }}>
                <div style={{ fontSize: 48, color: '#ff4d4f', marginBottom: 16 }}>
                    <ExclamationCircleFilled />
                </div>
                <div style={{ fontSize: 16, color: '#ff4d4f', marginBottom: 16, fontWeight: 600 }}>
                    {title}
                </div>
                <div style={{ color: '#666', marginBottom: 20, lineHeight: 1.5 }}>
                    {message}
                </div>
                <div style={{ fontSize: 14, color: '#999' }}>
                    Please try again or contact support if the problem persists.
                </div>
            </div>
        </Modal>
    );
};

export default ErrorDialog; 